import config from 'app/config';
import moment from 'moment';
/**
 * Красный 2216: за окно W было движение Galileosky и не было свежих данных 2216.
 * Одна util для значка и фильтра списка.
 */
export function isActivity2216Red(now, lastMotionGalileoskyDate, lastActivityDate, windowMs = config.activity2216RedWindowMs) {
    if (lastMotionGalileoskyDate == null || lastMotionGalileoskyDate === '') {
        return false;
    }
    const motionAgeMs = Math.max(0, moment(now).diff(moment(lastMotionGalileoskyDate)));
    if (motionAgeMs > windowMs) {
        return false;
    }
    if (lastActivityDate == null || lastActivityDate === '') {
        return true;
    }
    const activityAgeMs = Math.max(0, moment(now).diff(moment(lastActivityDate)));
    return activityAgeMs > windowMs;
}
